<div class="progressbar-wrapper">
    <p class="progressbar-title">{{progressTitle}}</p>
    <div class="progressbar-value"
         [ngStyle]="{'width': progress + '%', 'background-color': backgroundColor}">
    </div>
    <p class="progressbar-time">{{progressEstimatedTime}}</p>
</div>
